<p>{{lstFormat.length}} list (Format) in the system</p>

<mat-accordion displayMode="flat" multi togglePosition="before">
@for (lst of lstFormat; track $index) {
<mat-expansion-panel>
    <mat-expansion-panel-header>
        <div>Codelist name (code) : {{lst.code}}, <span style="margin-left: 15px; font-size: small;">
            label : {{lst.label}}, 
            {{lst.values.length}} values</span></div>
    </mat-expansion-panel-header>
    @for (val of lst.values; track $index) {
        <div>Value : <span class="highlited-value">{{val.value}}</span> 
            // SAS label <span class="highlited-value">{{val.sasLabel}}</span>
            // form label <span class="highlited-value">{{val.i18nCodeLabel}}</span>
        </div>
    }
</mat-expansion-panel>
}
</mat-accordion>
